var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Grid, Link, PasswordField, Spacer, TextField, Typography } from '@emburse/ui-core';
import { ShowModal } from '@Actions/index';
import { Api } from '@ClientServices/api';
import { SignUpDupeModal } from './SignUpDupeModal/SignUpDupeModal';
import SignUpReviews from './SignUpReviews/SignUpReviews';
import { SignUpTerms } from './SignUpTerms/SignUpTerms';
import * as style from './SignUpPage.styl';
export const SignUpPage = () => {
    var _a, _b, _c, _d;
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const channel = searchParams.get('channel');
    const [state, setState] = React.useState({
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        business_name: '',
        tos_accepted: false,
        partner_id: channel || ''
    });
    const [isSubmitting, setISubmitting] = React.useState(false);
    const defaultErrorState = {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        business_name: '',
        tos_accepted: ''
    };
    const [errorState, setErrorState] = React.useState(defaultErrorState);
    function validateFields() {
        const fields = ['first_name', 'last_name', 'password', 'email', 'business_name', 'tos_accepted'];
        const invalid = {};
        fields.forEach((field) => {
            if (!state[field]) {
                invalid[field] = '* Mandatory field';
            }
        });
        if (Object.keys(invalid).length > 0) {
            throw new Error(JSON.stringify({
                error: 'Please fill in all fields',
                validation_errors: invalid
            }));
        }
    }
    function createUser(bypassDupeCheck = false) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                validateFields();
                if (isSubmitting) {
                    toast.info('Already submitted! Please wait.');
                }
                else {
                    setISubmitting(true);
                }
                const resp = yield Api.constructRequest('POST', '/signup', Object.assign(Object.assign({}, state), { _csrf: window.csrf, newSignup: true, bypassDupeCheck }));
                if (resp.redirected) {
                    // we are rate limited
                    throw new Error(JSON.stringify({
                        error: 'Error Processing Request, please try again later.'
                    }));
                }
                window.location.href = '/signup/onboarding';
            }
            catch (e) {
                let errorMsg;
                try {
                    const parsed = JSON.parse(e.message);
                    errorMsg = parsed === null || parsed === void 0 ? void 0 : parsed.error;
                    setErrorState(Object.assign(Object.assign({}, defaultErrorState), ((parsed === null || parsed === void 0 ? void 0 : parsed.validation_errors) || {})));
                }
                catch (jsonErr) {
                    errorMsg = e.message;
                }
                if (errorMsg === 'dupe_company') {
                    showDupeModal();
                }
                else if (errorMsg) {
                    toast.error(errorMsg);
                }
            }
            finally {
                setISubmitting(false);
            }
        });
    }
    const logo = (_b = (_a = window.whitelabelConfiguration) === null || _a === void 0 ? void 0 : _a.tags) === null || _b === void 0 ? void 0 : _b.appLogoPath;
    const whiteLabelName = (_d = (_c = window.whitelabelConfiguration) === null || _c === void 0 ? void 0 : _c.tags) === null || _d === void 0 ? void 0 : _d.brandName;
    function updateStateAndClearError(field, value) {
        setState(Object.assign(Object.assign({}, state), { [field]: value }));
        setErrorState(Object.assign(Object.assign({}, errorState), { [field]: '' }));
    }
    function showDupeModal() {
        return dispatch(new ShowModal(SignUpDupeModal, {
            onConfirm: () => createUser(true),
            isLoading: isSubmitting
        }));
    }
    return (_jsx("div", Object.assign({ className: style.global, style: { height: '100%' } }, { children: _jsxs(Grid, Object.assign({ className: "page", container: true, alignItems: "flex-start", wrap: "nowrap", spacing: 0 }, { children: [_jsx(Grid, Object.assign({ item: true, container: true, className: "reviewsLeft", alignContent: "center" }, { children: _jsx(SignUpReviews, { initialSignupPage: true }) })), _jsx(Grid, Object.assign({ item: true, container: true, className: "signUpRight", alignContent: "center", justifyContent: "center" }, { children: _jsxs(Grid, Object.assign({ container: true, alignItems: "center", wrap: "nowrap", spacing: 3, direction: "column", className: "form" }, { children: [_jsxs(Grid, Object.assign({ item: true, className: "maxWidth centerText" }, { children: [_jsx("img", { className: "logo", alt: "logo", src: logo }), _jsx(Spacer, { size: '12px' })] })), _jsx(Grid, Object.assign({ item: true, className: "maxWidth" }, { children: _jsxs(Grid, Object.assign({ container: true, alignItems: "flex-start", wrap: "nowrap", spacing: 2 }, { children: [_jsx(Grid, Object.assign({ item: true, xl: true, className: "halfWidth" }, { children: _jsx(TextField, { label: "First Name ", required: true, fullWidth: true, value: state.first_name, onChange: (event) => updateStateAndClearError('first_name', event.target.value), error: Boolean(errorState.first_name), helperText: errorState.first_name }) })), _jsx(Grid, Object.assign({ item: true, xl: true, className: "halfWidth" }, { children: _jsx(TextField, { label: "Last Name", required: true, fullWidth: true, value: state.last_name, onChange: (event) => updateStateAndClearError('last_name', event.target.value), error: Boolean(errorState.last_name), helperText: errorState.last_name }) }))] })) })), _jsx(Grid, Object.assign({ item: true, className: "maxWidth" }, { children: _jsx(TextField, { label: "Legally Registered Business Name", required: true, fullWidth: true, value: state.business_name, onChange: (event) => updateStateAndClearError('business_name', event.target.value), error: Boolean(errorState.business_name), helperText: errorState.business_name }) })), _jsx(Grid, Object.assign({ item: true, className: "maxWidth" }, { children: _jsx(TextField, { label: "Work Email Address", required: true, fullWidth: true, value: state.email, onChange: (event) => updateStateAndClearError('email', event.target.value), error: Boolean(errorState.email), helperText: errorState.email }) })), _jsx(Grid, Object.assign({ item: true, className: "maxWidth" }, { children: _jsx(PasswordField, { id: "password", label: "Create Password", required: true, fullWidth: true, value: state.password, onChange: (event) => updateStateAndClearError('password', event.target.value), error: Boolean(errorState.password), helperText: errorState.password }) })), _jsx(Grid, Object.assign({ item: true }, { children: _jsxs(Typography, Object.assign({ variant: "body2", className: "centerText" }, { children: [whiteLabelName, " is designed exclusively for businesses based in the United States."] })) })), _jsx(Grid, Object.assign({ item: true, className: "maxWidth" }, { children: _jsx(SignUpTerms, { checked: state.tos_accepted, error: Boolean(errorState.tos_accepted), onChange: (newCheckedState) => updateStateAndClearError('tos_accepted', newCheckedState), whitelabelName: whiteLabelName, partner_id: state.partner_id }) })), _jsx(Grid, Object.assign({ item: true }, { children: _jsx(Button, Object.assign({ onClick: () => createUser(), disabled: isSubmitting }, { children: "Get Started" })) })), _jsxs(Grid, Object.assign({ item: true }, { children: [_jsx(Spacer, { size: '12px' }), _jsxs(Typography, { children: ["Already have an account?", ' ', _jsx(Link, Object.assign({ href: "/login", underline: "none" }, { children: "Login" }))] })] }))] })) }))] })) })));
};
export default SignUpPage;
